var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlerts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6.05627V9.37068M9.5 12.6851H9.50814M8.10883 1.79724L1.21805 13.5137C1.07598 13.7643 1.0008 14.0484 1.00001 14.3378C0.999211 14.6271 1.07282 14.9117 1.21351 15.1631C1.3542 15.4145 1.55707 15.6239 1.80194 15.7707C2.0468 15.9174 2.32513 15.9963 2.60922 15.9995H16.3908C16.6749 15.9963 16.9532 15.9174 17.1981 15.7707C17.4429 15.6239 17.6458 15.4145 17.7865 15.1631C17.9272 14.9117 18.0008 14.6271 18 14.3378C17.9992 14.0484 17.924 13.7643 17.782 13.5137L10.8912 1.79724C10.7461 1.55372 10.5419 1.35238 10.2983 1.21265C10.0546 1.07292 9.77965 0.999512 9.5 0.999512C9.22035 0.999512 8.94543 1.07292 8.70175 1.21265C8.45807 1.35238 8.25386 1.55372 8.10883 1.79724Z",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.34566c239983bf5a7fa9c000ecaa856a.svg";
export { ForwardRef as ReactComponent };